// client/src/pages/RecruitCreate.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_API_URL}/api`;

export default function RecruitCreate() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("Club");
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setImageFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const uploadImage = async () => {
    if (!imageFile) return "";
    const token = localStorage.getItem("cp_token");
    const fd = new FormData();
    fd.append("image", imageFile);

    const res = await fetch(`${API}/upload`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: fd,
    });

    const d = await res.json();
    return res.ok ? d.url : "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return navigate("/login");
    if (!title || !description) return alert("Fill title and description");

    setSaving(true);
    try {
      const imageUrl = await uploadImage();
      const token = localStorage.getItem("cp_token");
      const res = await fetch(`${API}/opportunities`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ title, description, category, imageUrl }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error || "Failed");
      navigate(`/recruit/${d.item._id}`);
    } catch (err) {
      alert(err.message || "Error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen p-6 bg-slate-50 text-slate-900 dark:text-slate-100
 dark:bg-slate-900">
      <div className="max-w-3xl mx-auto bg-white dark:bg-slate-800 p-6 rounded-xl shadow">
        <h2 className="text-2xl font-bold dark:text-white">Create Opportunity</h2>

        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title (e.g., Club recruiting)" className="w-full p-2 rounded border dark:bg-slate-700" />
          <textarea value={description} onChange={(e) => setDescription(e.target.value)} rows={4} placeholder="Describe role/requirements" className="w-full p-2 rounded border dark:bg-slate-700" />

          <select value={category} onChange={(e) => setCategory(e.target.value)} className="w-full p-2 rounded-lg border dark:border-slate-600 
             bg-white dark:bg-slate-700 
             text-slate-900 dark:text-slate-100">
            <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100">Club</option>
            <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100">Event</option>
            <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100">Volunteer</option>
            <option className="bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100">Project</option>
          </select>

          <div>
            <input type="file" accept="image/*" onChange={handleFile} className="text-slate-900 dark:text-slate-100
             file:bg-slate-200 dark:file:bg-slate-700
             file:text-slate-900 dark:file:text-slate-100
             file:rounded-md file:border-0 file:px-3 file:py-1" />
            {preview && <img src={preview} alt="preview" className="mt-3 w-full h-48 object-cover rounded" />}
          </div>

          <div className="flex gap-3">
            <button className="px-4 py-2 bg-indigo-600 text-white rounded" disabled={saving}>{saving ? "Posting..." : "Post"}</button>
            <button type="button" onClick={() => navigate(-1)} className="px-4 py-2 border rounded dark:text-white">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}
